import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import isPlainObject from 'lodash/isPlainObject';
import { createPrettyKeyCombinations, useCodeKeyMap, } from 'utils/keyboard';
import { keyboardKeyCombinationVariantConfig, } from '../keyboardKeyCombination/keyboardKeyCombination';
import styles from '../keyboardKeyCombination/keyboardKeyCombination.module.scss';
/** Represents a components for displaying multiple keyboard key combinations. */
export const KeyboardKeyCombinations = (props) => {
    var _a;
    const codeKeyMap = useCodeKeyMap();
    const { keyCombinations, variant = 'plain' } = props;
    const { wrapperFn, prettyKeyCombinationsOptions } = isCustomVariant(variant)
        ? variant
        : keyboardKeyCombinationsVariantConfig[variant];
    const content = createPrettyKeyCombinations(keyCombinations, Object.assign(Object.assign({}, prettyKeyCombinationsOptions), { codeKeyMap }));
    return _jsx(_Fragment, { children: (_a = wrapperFn === null || wrapperFn === void 0 ? void 0 : wrapperFn(content)) !== null && _a !== void 0 ? _a : content });
};
/** Represents the variants configuration. */
export const keyboardKeyCombinationsVariantConfig = {
    plain: {
        prettyKeyCombinationsOptions: Object.assign(Object.assign({}, keyboardKeyCombinationVariantConfig.plain.prettyKeyCombinationOptions), { keyCombinationSeparator: ' or ', keyCombinationTransformFn: (keyCombination, index) => (_jsx("kbd", Object.assign({ className: styles.kbd }, { children: keyCombination }), index)) }),
        wrapperFn: keyboardKeyCombinationVariantConfig.plain.wrapperFn,
    },
    simple: {
        prettyKeyCombinationsOptions: Object.assign(Object.assign({}, keyboardKeyCombinationVariantConfig.simple.prettyKeyCombinationOptions), { keyCombinationSeparator: ' or ', keyCombinationTransformFn: (keyCombination, index) => (_jsx(FlexBox, Object.assign({ className: styles.kbd, as: "kbd", gap: "100", alignItems: "center" }, { children: keyCombination }), index)) }),
        wrapperFn: keyboardKeyCombinationVariantConfig.simple.wrapperFn,
    },
    rich: {
        prettyKeyCombinationsOptions: Object.assign(Object.assign({}, keyboardKeyCombinationVariantConfig.rich.prettyKeyCombinationOptions), { keyCombinationSeparator: ' or ', keyCombinationTransformFn: (keyCombination, index) => (_jsx(FlexBox, Object.assign({ className: styles.kbd, as: "kbd", gap: "100", alignItems: "center" }, { children: keyCombination }), index)) }),
        wrapperFn: keyboardKeyCombinationVariantConfig.rich.wrapperFn,
    },
};
/** A type guard for determining whether the variant is a custom configuration. */
function isCustomVariant(variant) {
    return isPlainObject(variant);
}
